module.exports = __webpack_public_path__ + "img/banner.c5ccd667.png";